import React, { FC, memo, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import { MainSidebar } from '@/components/MainSidebar/MainSidebar'
import { focusIds } from '@/constants/focus'
import { mainPaths, paths } from '@/constants/paths'
import { EventDetailPage } from '@/containers/EventDetailPage/EventDetailPage'
import { useOpenPrevEventPopup } from '@/hooks/useOpenPrevEventPopup'
import useStore from '@/store/useStore'
import { sendPageViewEvent } from '@/utils/analyticsUtils'
import { sendPageImpressionToGTAG } from '@/utils/utils'

import { PopupBG } from './styles'

const focusId = `${focusIds.EVENT_PAGE}_${focusIds.POPUP}${focusIds.CONTAINER_MOD}`

const EventDetailsPopupRaw: FC = () => {
  const currentEvent = useStore((state) => state.common.currentEvent)
  const openPrevEventPopup = useOpenPrevEventPopup()

  const { pathname } = useLocation()

  useEffect(() => {
    if (currentEvent?.id) {
      sendPageImpressionToGTAG(`${paths.EVENT_PAGE}/${currentEvent?.id}`)
      sendPageViewEvent(`${paths.EVENT_PAGE}/${currentEvent?.id}`)
    }
  }, [currentEvent?.id])

  if (!currentEvent || !mainPaths.some((path) => pathname.includes(path))) {
    return null
  }

  return (
    <PopupBG focusId={focusId} isTrap>
      <MainSidebar
        focusIdPrefix={`${focusIds.EVENT_PAGE}_${focusIds.POPUP}`}
        onBack={openPrevEventPopup}
        disableSubMenuAutoOpen
      />
      <EventDetailPage isPopup />
    </PopupBG>
  )
}

export const EventDetailsPopup = memo(EventDetailsPopupRaw)
